<template>
    <div class="general-frame">
        <div style="height: 100%; width: 100%;padding: 2%;box-sizing: border-box;color: #fff;background: #0d274d;"
            class="flex">

            <el-row style="height: 100%;width: 100%;flex: 1;" class="my-row">
                <el-tabs tabPosition="top" v-model="activeName" @tab-click="tabClick">
                    <el-tab-pane label="基本信息" name="first">
                        <dv-border-box-7 v-if="activeName == 'first'" :color="['rgb(69, 162, 255)']">

                            <div style="padding: 30px 0 10px 62px;">
                                <dv-decoration-3 style="width:250px;height:30px;" />
                            </div>

                            <PvStationSelect style="display: flex;margin: 20px 62px;" :pvId="pvId" :toiletType="2"
                                :width="'25%'" @getId="res => {
                                    pvId = res;
                                    getBaseInfo();
                                    // methodBody();
                                }" />

                            <el-row class="baseInfo">
                                <el-col :span="24">
                                    <div class="info-box">电站名称：{{ station.name }}</div>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-box">唯一标识：{{ station.id }}</div>
                                </el-col>
                                <!-- <el-col :span="24">
                                    <div class="info-box">类型：{{ dict[station.type] }}</div>
                                </el-col> -->
                                <el-col :span="24">
                                    <div class="info-box">经纬度：{{ station.locationLng }}, {{ station.locationLat }}</div>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-box">开始运营时间：{{ station.startOperatingTime ?
                                        station.startOperatingTime.split("T")[0] : '' }}</div>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-box">地址：{{ station.locationAddress }}</div>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-box">装机容量：{{ station.installedCapacity }}kWp</div>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-box">并网类型：{{ dict[station.gridInterconnectionType] }}</div>
                                </el-col>
                                <el-col :span="24">
                                    <div class="info-box">网络状态：{{ dict[station.networkStatus] }}</div>
                                </el-col>
                                <el-col :span="4">
                                    <div class="info-box">累计运行天数：{{ station.totalRunningDayCount }}天</div>
                                </el-col>
                                <!-- <el-col :span="12">
                                    <div class="info-box">累计发电量：{{ generationValue }} kWh</div>
                                </el-col> -->
                                <el-col :span="24">
                                    <div class="info-box" style="display: flex;align-items: center;">绑定公厕：
                                        <ToiletSelect :toiletId="station.toiletId" :toiletType="2" :width="'80%'" @getId="res => {
                                            updateToiletId(res)
                                        }" />
                                    </div>
                                </el-col>
                            </el-row>
                        </dv-border-box-7>
                    </el-tab-pane>
                    <el-tab-pane label="实时" name="second">
                        <div v-if="activeName == 'second'" style="padding: 5px;height: 100%;">
                            <dv-border-box-12 style="width: 59%;height: 98%;float: left;">
                                <div
                                    style="display: flex; align-items: center;justify-content: center; width: 100%;height: 100%;">
                                    <div>
                                        <div class="gl-box" style="margin-bottom: 70px;">
                                            <dv-border-box-7 :color="['rgb(69, 162, 255)']" style="width: 200px;">
                                                <div
                                                    style="padding: 10px;display: flex;align-items: center;flex-direction: column;">
                                                    <svg t="1684400030653" class="icon" viewBox="0 0 1024 1024"
                                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3341"
                                                        width="48" height="48">
                                                        <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z"
                                                            fill="#E99413" opacity=".2" p-id="3342"></path>
                                                        <path
                                                            d="M385.789961 530.769006c-25.843358-13.931956-37.617486-42.544847-31.81712-69.823545 6.121873-28.739326 27.98794-49.118274 56.390105-52.540454 28.970522-3.485999 54.127517 10.07508 67.82587 36.568676 9.932991 19.219357 16.766513 21.933499 36.321826 12.081186 20.726946-10.444753 40.94213-21.919049 61.290975-33.126026 2.944134-1.620779 7.251361-2.647915 6.485525-8.562675-7.211624-2.684039-14.125824 0.922375-21.000287 2.139766-12.969845 2.299917-25.760272 5.590845-38.714463 8.009972-3.927921 0.730916-9.241812 2.462476-11.80664-1.578634-2.814087-4.426437 2.012126-7.674015 4.438478-10.832488 16.057272-20.952121 32.551649-41.538182 50.431996-61.011613 5.587232-6.086952 13.028848-11.585078 14.538845-24.285194-35.876293 22.234535-66.365242 47.89968-105.625181 65.235753 8.119549-27.006562 15.125264-50.327236 22.129775-73.650318-1.195716-0.552703-2.391432-1.107813-3.588352-1.662924-16.188524 18.840051-26.219051 42.523173-45.415529 61.352386-1.572613-5.795549-3.380035-10.114817-3.853264-14.576174-3.011566-28.321488-7.187541-56.54544-7.534334-85.111369-0.048166-4.720248-0.585214-9.489866-1.522039-14.106557-0.322711-1.59188-2.537133-2.800841-3.88698-4.184404-1.389583 1.401625-3.43663 2.580483-4.023048 4.261469-1.01389 2.944134-1.054831 6.218204-1.625596 9.329715-6.096586 33.358426-12.013754 66.763814-23.450722 100.827868-15.486507-22.370604-22.996759-46.667839-37.86554-67.30327 0.223971 26.844002 10.158166 52.106962 8.862507 80.050348-32.610652-24.887267-64.54337-48.824463-96.195523-74.125956 18.796702 33.8449 41.546611 64.772158 61.192235 103.003759-27.617063-8.807116-50.456079-16.095805-73.304729-23.384494-0.6683 1.401625-1.335397 2.798433-2.006105 4.197649 21.114681 14.649627 43.221577 28.097517 64.103857 47.163947-42.18842 10.010056-82.529683 8.342316-121.767948 17.08802 38.51337 10.889082 78.103246 15.367297 117.116336 29.464222-22.262231 15.938062-46.629307 24.252682-67.087728 39.44297 21.027982-1.500365 41.042075-5.277767 61.12119-8.663823 3.844835-0.646626 9.027474-2.638281 11.387599 2.26018 1.896528 3.930329-1.997676 6.798602-4.357801 9.423638-15.511795 17.23613-26.965621 37.733084-44.308919 53.626593-8.59037 7.873903-14.885639 18.257245-22.41877 27.751927 6.890117 4.130217 9.40678-0.677934 12.624255-2.734613 24.889675-15.94047 49.632444-32.119361 74.595572-47.944233 4.145871-2.627444 8.95643-8.633719 13.751335-4.633549 4.554076 3.795465-0.09874 9.951053-1.444974 14.741141-3.70395 13.210674-8.383257 26.14319-12.170292 39.329781-1.410054 4.924953-6.516832 9.717449-2.333633 15.957328 5.331954-4.737106 49.583074-67.279188 52.552495-73.065104 5.94968-11.581466 5.529433-19.084492-8.035259-26.400877z"
                                                            fill="#E99413" p-id="3343"></path>
                                                        <path
                                                            d="M788.306699 421.199046c-41.033646 7.153825-82.150377 13.862116-123.217738 20.867831-71.217946 12.157047-142.416625 24.395976-213.627345 36.599984-12.119718 2.074742-21.832351 7.145396-26.461084 19.611908-25.3328 68.243708-50.952187 136.383859-76.118816 204.690182-5.636602 15.303477-1.519631 21.250749 14.950663 22.96786 55.04628 5.741363 110.122663 11.264775 165.200251 16.761697 69.252781 6.916608 138.515195 13.724843 202.809307 20.089953 28.067413 1.130692 37.163524-6.543323 40.934906-30.183096 15.050607-94.246012 30.018128-188.514904 45.175904-282.748875 4.373454-27.159488-2.137357-33.445124-29.646048-28.657444z m4.628733 37.039497c-9.547665 56.143256-19.410816 112.232325-29.076486 168.35511-4.835846 28.062597-9.853518 56.098702-14.15954 84.245589-4.060377 26.589928-3.696725 26.644114-41.471954 25.101604-59.714749-5.166986-130.617209-11.365924-201.524485-17.403506-42.553276-3.617251-85.100532-7.377796-127.710404-10.211148-12.237725-0.811594-16.065701-3.970066-11.477909-16.199362 23.335124-62.2278 46.331883-124.586851 69.245557-186.973598 2.781575-7.572867 8.106303-10.303868 15.432321-11.439376 74.489607-11.530891 148.982827-23.059375 223.435105-34.845545 33.835267-5.350016 67.569386-11.310533 101.367325-16.888132 18.382476-3.039262 19.13025-2.479334 15.94047 16.258364z"
                                                            fill="#E99413" p-id="3344"></path>
                                                        <path
                                                            d="M707.61695 581.281681c-14.741142 0.883842-29.475059 2.19636-44.235467 2.556399-31.470327 0.777878-47.296403 12.956599-55.012563 43.314296-4.422824 17.393873-8.92753 34.772092-12.937333 52.255072-3.688296 16.081355 9.323694 34.870832 25.718127 36.447057 24.134676 2.326408 48.360867 3.793056 72.554546 5.569171 6.436154 0.470821 12.228091-0.683954 17.946576-4.48544 17.401098-11.559791 29.968758-25.254531 31.19819-47.926171 0.84531-15.681579 4.198853-31.463102 8.347132-46.670248 3.9219-14.39796-1.242678-23.68553-11.013109-33.46439-9.866763-9.873988-21.186929-7.453657-32.566099-7.595746zM744.797332 454.747727c-18.776231 2.420331-37.495868 5.282584-56.204667 8.170123-27.135405 4.186812-45.015753 18.489645-50.717379 46.37162-2.532317 12.37018-5.32232 24.746382-9.092498 36.778197-3.028424 9.670488-0.437105 16.406474 5.388549 24.465816 8.819157 12.177517 20.274188 8.579532 35.134539 8.616861 10.010056-0.727304 23.632548-2.222851 37.29598-2.612994 40.134149-1.129488 56.282936-15.219187 62.602289-55.228106 1.807421-11.429743 3.573902-22.878753 5.85094-34.219389 3.914675-19.489085-10.166595-34.931039-30.257753-32.342128zM571.123514 587.262668c-13.871749 1.115038-25.934873 2.243322-38.022079 3.010362-17.121736 1.08373-33.772652 13.16612-39.218999 29.358257-5.708851 16.980851-11.192527 34.049605-16.378779 51.197833-6.477095 21.444616 3.701541 36.173717 25.743414 37.855907 9.457354 0.71767 18.938791 1.19692 28.352795 2.2951 34.522834 4.026661 52.140678-8.203839 60.712986-42.28114 3.218679-12.772365 5.191069-26.140781 10.3713-38.08349 11.078133-25.506197-6.123077-48.811217-31.560638-43.352829zM452.839157 593.826462c-30.99469 0.621339-31.44504 0.207113-43.248068 12.87833-19.180824 20.604123-22.976289 48.170612-29.997657 73.706913-2.914031 10.597679 4.673286 21.420533 19.17962 21.696282 10.545901 0.202296 21.095414 0.567152 31.624457 1.208962 18.55226 1.122263 35.23328-9.539236 41.198613-27.065565 4.414395-12.969845 8.432627-26.076962 12.505045-39.162404 11.967996-38.508554 7.944948-44.050028-31.26201-43.262518z"
                                                            fill="#E99413" p-id="3345"></path>
                                                        <path
                                                            d="M427.004229 591.131586c17.905635 7.257381 64.707134-4.088072 75.787675-19.675728 5.934026-8.342316 8.722826-18.911096 12.930108-28.472006-0.840493 4.640774-1.447382 9.346573-2.566033 13.924732-4.489052 18.41258 4.159116 29.351032 23.100316 28.875394 13.143242-0.326323 26.334649-0.242033 39.420091-1.366704 27.74109-2.378186 43.534654-16.650916 49.952747-43.736951 2.909214-12.273849 6.361497-24.414038 9.365839-36.667416 4.751556-19.424061-6.604735-32.065174-26.025184-29.089732-13.506893 2.069925-26.948763 4.841867-40.521884 6.121872-12.93372 1.216186-22.153858 7.73061-31.337871 16.196953-11.296083 10.42067-10.347217 26.266013-18.762985 37.700573 1.782134-7.657157 3.588352-15.322744 5.345199-22.987126 2.44321-10.665111-3.448671-20.613756-11.857215-20.645065-19.638399-0.075861-40.564029-0.437105-58.010884 10.609721-26.214234 16.596729-27.356968 47.008612-36.45067 72.700248-1.994064 5.641419 2.313162 13.545426 9.630751 16.511235z"
                                                            fill="#E99413" p-id="3346"></path>
                                                    </svg>
                                                    <dv-decoration-7 class="labeal-title">发电</dv-decoration-7>
                                                    <dv-digital-flop class="labeal-value"
                                                        :config="{ number: [station.generationPower], content: '{nt}W', style: { color: '#0dede0', fontSize: 18 } }" />
                                                </div>
                                            </dv-border-box-7>
                                            <div class="container1">
                                                <div v-show="station.generationPower > 0" class="ball"></div>
                                                <div v-show="station.generationPower > 0" class="arrow"></div>
                                                <!-- <div class="ball-reverse"></div>
                                                <div class="arrow-reverse"></div> -->
                                            </div>
                                        </div>
                                        <div class="gl-box">
                                            <div class="container2">
                                                <div v-show="station.batteryPower < 0" class="ball"></div>
                                                <div v-show="station.batteryPower < 0" class="arrow"></div>
                                                <div v-show="station.batteryPower > 0" class="ball-reverse"></div>
                                                <div v-show="station.batteryPower > 0" class="arrow-reverse"></div>
                                            </div>
                                            <dv-border-box-7 :color="['rgb(69, 162, 255)']" style="width: 200px;">
                                                <div
                                                    style="padding: 10px;display: flex;align-items: center;flex-direction: column;">
                                                    <svg t="1684400738461" class="icon" viewBox="0 0 1024 1024"
                                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5089"
                                                        width="48" height="48">
                                                        <path
                                                            d="M635.936508 1024V567.351351l322.333762-180.001716v456.538825l-322.333762 180.11154z"
                                                            fill="#99C9F2" p-id="5090"></path>
                                                        <path
                                                            d="M635.936508 1024L79.128271 700.348348V243.809524l556.808237 323.541827v456.648649z"
                                                            fill="#B8D9F6" p-id="5091"></path>
                                                        <path
                                                            d="M636.375804 622.812527v-50.848563l342.211927-191.203775v50.848563L636.375804 622.812527z"
                                                            fill="#99C9F2" p-id="5092"></path>
                                                        <path
                                                            d="M636.375804 622.812527L45.412269 279.392535V228.434148l590.963535 343.529816v50.848563z"
                                                            fill="#B8D9F6" p-id="5093"></path>
                                                        <path
                                                            d="M636.375804 571.963964L45.412269 228.434148 387.624196 37.340197l590.963535 343.419992-342.211927 191.203775z"
                                                            fill="#E0EFFB" p-id="5094"></path>
                                                        <path
                                                            d="M631.214071 516.832261V444.787645l284.554269-159.025311v72.044616L631.214071 516.832261z"
                                                            fill="#99C9F2" p-id="5095"></path>
                                                        <path
                                                            d="M631.214071 516.832261L139.531532 231.179751v-72.15444L631.214071 444.787645v72.044616z"
                                                            fill="#B8D9F6" p-id="5096"></path>
                                                        <path
                                                            d="M631.214071 444.787645L139.531532 159.025311 424.195624 0l491.572716 285.762334L631.214071 444.787645z"
                                                            fill="#E0EFFB" p-id="5097"></path>
                                                        <path
                                                            d="M316.458172 133.326469a12.629773 12.629773 0 0 1 0 23.722008 45.137709 45.137709 0 0 1-40.964393 0 12.519949 12.519949 0 0 1 0-23.612184 45.137709 45.137709 0 0 1 40.964393-0.109824zM520.072072 166.932647c9.88417 5.710854 9.993994 14.826255 0 20.537108a39.207207 39.207207 0 0 1-35.583012 0L350.723295 109.82411a10.982411 10.982411 0 0 1 0-20.537109 38.987559 38.987559 0 0 1 35.473187 0zM749.494637 299.270699c9.88417 5.710854 9.88417 14.826255 0 20.427285a38.987559 38.987559 0 0 1-35.473187 0l-134.095238-76.876877a10.982411 10.982411 0 0 1 0-20.537109 38.987559 38.987559 0 0 1 35.473187 0zM676.791077 343.200343a12.519949 12.519949 0 0 1 0 23.612184 44.918061 44.918061 0 0 1-40.854569 0c-10.982411-6.589447-10.982411-17.132561 0-23.722008a45.137709 45.137709 0 0 1 40.854569 0.109824z"
                                                            fill="#5CA8EA" p-id="5098"></path>
                                                    </svg>
                                                    <dv-decoration-7 class="labeal-title">
                                                        电池
                                                        <dv-digital-flop class="labeal-value" style="width: 40px;"
                                                            :config="{ number: [station.batterySoc], content: '{nt}%', style: { fontSize: 15 } }" />
                                                    </dv-decoration-7>
                                                    <dv-digital-flop class="labeal-value"
                                                        :config="{ number: [station.batteryPower], content: '{nt}W', style: { color: '#0dede0', fontSize: 18 } }" />
                                                </div>
                                            </dv-border-box-7>
                                        </div>
                                    </div>
                                    <div style="width: 220px;margin-right: 100px;">
                                        <svg t="1684399651271" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                            xmlns="http://www.w3.org/2000/svg" p-id="2703" width="180" height="180">
                                            <path
                                                d="M2.1 962.2h76.4L164 472.6H52.2v59.5H17.5v-94.4l150.1-120.8v-71.5H52.3v59.5H17.5v-94.3l150.1-121V64.4c0-31.3 26.7-52.4 56.5-52.6l133.4-0.1c29.9 0 57 21.5 57 52.8V90l150.3 120.9v94h-34.9v-59.5H414.5v71.7l150.3 120.8v60.7h-34.9v-26.1H418.1l4.6 26.1h-92.9l26.1-26.1H226.1l64.8 64.5 20.2-19.9-10 60.6-10.1-10-90.5 89.9L291 764.4l28.7-33.8h7.6v24.5l-22 26 22 26v33.6L291 797.9 151.9 962.2h197.6V732.3h610.1v229.9h62.5v50.1H2l0.1-50.1z m188-283.3l-44.9 257.7 131.6-155.5-86.7-102.2z m31.6-180.1L199 628.5l76.6-76.1-53.9-53.6zM229 409l49.2-69.6-49.2-69.6V409z m62.5-88.4l53.1-75.2H238.3l53.2 75.2z m61.5-49.5l-48.3 68.3 48.3 68.3V271.1z m-61.5 87.1l-56.1 79.5h112.3l-56.2-79.5zM229 186.3l47.1-47.1-47.1-47v94.1z m62.5-62.5L342.3 73l-101.6-0.1 50.8 50.9zM353 93.2l-46.1 46.1 46.1 46.1V93.2z m-61.5 61.5l-55.9 55.9h111.7l-55.8-55.9z m123 204.2v78.9h97.9l-97.9-78.9zM69.3 437.7h98.3v-79l-98.3 79z m345.2-305.9v78.7h97.9l-97.9-78.7zM69.4 210.5h98.2v-79l-98.2 79zM976 520.9H855v-51.7h5.6v-26.9h-85.4v26.9h5.5v81.2h-13.1v-29.5H333.1L307.9 675v33.3h693.3V675L976 520.9zM456.4 962.2h101V780h-101v182.2zM804.5 780H703.6v119.7h100.9V780z"
                                                p-id="2704" fill="#1296db"></path>
                                        </svg>
                                    </div>
                                    <div>
                                        <div class="gl-box" style="margin-bottom: 70px;">
                                            <dv-border-box-7 :color="['rgb(69, 162, 255)']" style="width: 200px;">
                                                <div
                                                    style="padding: 10px;display: flex;align-items: center;flex-direction: column;">
                                                    <svg t="1684400641768" class="icon" viewBox="0 0 1048 1024"
                                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3874"
                                                        width="48" height="48">
                                                        <path
                                                            d="M343.04 1024H79.555048l52.053333-763.928381h159.378286z m-211.309714-48.761905h159.134476l-45.470476-666.404571h-68.266667z"
                                                            p-id="3875" fill="#1296db"></path>
                                                        <path d="M0 438.857143h414.47619v48.761905H0z" p-id="3876"
                                                            fill="#1296db"></path>
                                                        <path d="M24.380952 365.714286h48.761905v73.142857H24.380952z"
                                                            p-id="3877" fill="#1296db"></path>
                                                        <path d="M341.333333 365.714286h48.761905v73.142857h-48.761905z"
                                                            p-id="3878" fill="#1296db"></path>
                                                        <path d="M0 975.238095h414.47619v48.761905H0z" p-id="3879"
                                                            fill="#1296db"></path>
                                                        <path
                                                            d="M939.349333 1015.881143h-287.695238L708.85181 0h173.275428z m-236.153904-48.761905h184.58819L836.022857 48.761905h-81.066667z"
                                                            p-id="3880" fill="#1296db"></path>
                                                        <path d="M560.761905 170.666667h463.238095v48.761904H560.761905z"
                                                            p-id="3881" fill="#1296db"></path>
                                                        <path d="M585.142857 97.52381h48.761905v73.142857h-48.761905z"
                                                            p-id="3882" fill="#1296db"></path>
                                                        <path d="M560.761905 975.238095h487.619047v48.761905H560.761905z"
                                                            p-id="3883" fill="#1296db"></path>
                                                        <path
                                                            d="M701.147429 248.003048l34.474666-34.474667 162.377143 162.377143-34.474667 34.474666z"
                                                            p-id="3884" fill="#1296db"></path>
                                                        <path
                                                            d="M128.926476 502.710857l34.718476-34.230857 150.284191 152.405333-34.718476 34.230857z"
                                                            p-id="3885" fill="#1296db"></path>
                                                        <path
                                                            d="M116.004571 808.764952l34.474667-34.474666 183.710476 183.710476-34.474666 34.474667z"
                                                            p-id="3886" fill="#1296db"></path>
                                                        <path
                                                            d="M691.321905 517.607619l157.817905-157.817905 34.474666 34.474667-157.817905 157.817905z"
                                                            p-id="3887" fill="#1296db"></path>
                                                        <path
                                                            d="M106.179048 785.798095l157.817904-157.817905 34.474667 34.474667-157.817905 157.817905z"
                                                            p-id="3888" fill="#1296db"></path>
                                                        <path
                                                            d="M701.147429 516.193524l34.474666-34.474667 180.662857 180.662857-34.474666 34.474667z"
                                                            p-id="3889" fill="#1296db"></path>
                                                        <path
                                                            d="M676.08381 825.417143l173.056-173.056 34.474666 34.474667-173.056 173.056z"
                                                            p-id="3890" fill="#1296db"></path>
                                                        <path
                                                            d="M701.805714 858.160762l33.158096-35.791238 165.522285 153.35619-33.158095 35.766857z"
                                                            p-id="3891" fill="#1296db"></path>
                                                        <path
                                                            d="M949.321143 203.897905l-29.525333-38.814476a695.417905 695.417905 0 0 0 83.334095-72.923429l35.961905 32.914286a729.35619 729.35619 0 0 1-89.770667 78.823619z"
                                                            p-id="3892" fill="#1296db"></path>
                                                        <path
                                                            d="M346.624 409.6q-12.190476 0-24.380952-0.292571l1.194666-48.761905a923.769905 923.769905 0 0 0 382.073905-72.118857l18.822095 45.007238A974.140952 974.140952 0 0 1 346.624 409.6z"
                                                            p-id="3893" fill="#1296db"></path>
                                                        <path
                                                            d="M26.819048 414.744381q-10.532571 0-21.211429-0.268191l1.170286-48.761904a813.056 813.056 0 0 0 581.802666-229.790476l35.986286 32.914285A850.480762 850.480762 0 0 1 26.819048 414.744381z"
                                                            p-id="3894" fill="#1296db"></path>
                                                    </svg>
                                                    <dv-decoration-7 class="labeal-title">电网</dv-decoration-7>
                                                    <dv-digital-flop class="labeal-value"
                                                        :config="{ number: [station.wirePower], content: '{nt}W', style: { color: '#0dede0', fontSize: 18 } }" />
                                                </div>
                                            </dv-border-box-7>
                                            <div class="container3">
                                                <div v-show="station.wirePower < 0" class="ball"></div>
                                                <div v-show="station.wirePower < 0" class="arrow"></div>
                                                <div v-show="station.wirePower > 0" class="ball-reverse"></div>
                                                <div v-show="station.wirePower > 0" class="arrow-reverse"></div>
                                            </div>
                                        </div>
                                        <div class="gl-box">
                                            <div class="container4">
                                                <!-- <div class="ball"></div>
                                                <div class="arrow"></div> -->
                                                <div v-show="station.usePower > 0" class="ball-reverse"></div>
                                                <div v-show="station.usePower > 0" class="arrow-reverse"></div>
                                            </div>
                                            <dv-border-box-7 :color="['rgb(69, 162, 255)']" style="width: 200px;">
                                                <div
                                                    style="padding: 10px;display: flex;align-items: center;flex-direction: column;">
                                                    <svg t="1684400827301" class="icon" viewBox="0 0 1024 1024"
                                                        version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8036"
                                                        width="48" height="48">
                                                        <path
                                                            d="M384.277504 24.596173 124.906802 24.596173c-60.50857 0-109.732557 49.232282-109.732557 109.728051l0 738.190579c0 60.478464 49.226138 109.730099 109.732557 109.730099L384.277455 982.244902c60.509594 0 109.734605-49.252762 109.734605-109.731123L494.01206 134.325311C494.014157 73.830502 444.788019 24.596173 384.277504 24.596173zM434.157466 872.514867c0 27.512627-22.375526 49.878016-49.880064 49.878016L124.906802 922.392883c-27.50249 0-49.880064-22.365389-49.880064-49.878016L75.026738 134.325311c0-27.508531 22.378598-49.878016 49.880064-49.878016L384.277455 84.447295c27.505562 0 49.880064 22.368461 49.880064 49.878016L434.157519 872.514867zM903.022899 24.596173 643.651178 24.596173c-60.506522 0-109.733581 49.232282-109.733581 109.728051l0 738.190579c0 60.478464 49.227162 109.730099 109.733581 109.730099L903.022854 982.244902c60.50857 0 109.732557-49.252762 109.732557-109.731123L1012.755411 134.325311C1012.75648 73.830502 963.531366 24.596173 903.022899 24.596173zM952.899789 872.514867c0 27.512627-22.374502 49.878016-49.876992 49.878016L643.651178 922.392883c-27.501466 0-49.87904-22.365389-49.87904-49.878016L593.772138 543.31624l359.128675 0L952.900813 872.514867 952.899789 872.514867zM952.899789 483.466138 593.772167 483.466138 593.772167 134.325311c0-27.508531 22.377574-49.878016 49.87904-49.878016L903.022854 84.447295c27.50249 0 49.876992 22.368461 49.876992 49.878016L952.899846 483.46613zM114.9312 124.351181l279.322829 0 0 59.849114-279.322829 0 0-59.849114ZM114.9312 224.105062l279.322829 0 0 59.850138-279.322829 0 0-59.850138ZM114.9312 323.855974l279.322829 0 0 59.855258-279.322829 0 0-59.855258ZM675.245056 373.734912c-19.298304 0-34.912563 15.644262-34.912563 34.914202s15.614259 34.91113 34.912563 34.91113c19.270656 0 34.913587-15.642214 34.913587-34.91113S694.515712 373.734912 675.245056 373.734912zM675.245056 663.03488c19.270656 0 34.913587-15.66679 34.913587-34.915226 0-19.288269-15.642931-34.913178-34.913587-34.912154-19.298304 0-34.912563 15.625933-34.912563 34.912154C640.332493 647.36809 655.946752 663.03488 675.245056 663.03488z"
                                                            p-id="8037" fill="#1196db"></path>
                                                    </svg>
                                                    <dv-decoration-7 class="labeal-title">用电</dv-decoration-7>
                                                    <dv-digital-flop class="labeal-value"
                                                        :config="{ number: [station.usePower], content: '{nt}W', style: { color: '#0dede0', fontSize: 18 } }" />
                                                </div>
                                            </dv-border-box-7>
                                        </div>
                                    </div>
                                </div>
                            </dv-border-box-12>
                            <dv-border-box-12 style="width: 39%;height: 98%;float: right;">
                                <div style="width: 100%;height: 50%;padding: 20px 10px;box-sizing: border-box;">
                                    <div ref="hours-box" style="width: 98%;height: 100%;"></div>
                                </div>
                                <div style="width: 100%;height: 50%;padding: 20px 10px;box-sizing: border-box;">
                                    <div ref="b1" style="width: 48%;height: 100%;float: left;"></div>
                                    <div ref="b2" style="width: 48%;height: 100%;float: right;"></div>
                                </div>
                            </dv-border-box-12>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="统计" name="third">
                        <dv-border-box-7 :color="['rgb(69, 162, 255)']">
                            <div
                                style="height: 100%;width: 100%;display: flex;flex-direction: column;padding: 60px 70px;box-sizing: border-box;">
                                <div class="select-group">
                                    <el-select class="dateType" v-model="selectDateTypeValue" placeholder="请选择"
                                        @change="selectDateTypeValueChange">
                                        <el-option v-for="item in options" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <el-date-picker :key="selectDateKey" class="data-input" :type="datePickerType"
                                        value-format="yyyy-MM" :disabled="datePickerDisabled" v-model="selectDateValue"
                                        @change="selectDateValueChange" placeholder="选择日期">
                                    </el-date-picker>
                                    <el-select v-model="params1" multiple placeholder="请选择参数" @change="params1Change"
                                        style="width: 500px;margin-left: 50px;">
                                        <el-option v-for="item in options2" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <!-- <el-button type="danger" @click="calibrationData"
                                        style="margin-left: 200px;">校准当月数据</el-button> -->
                                </div>

                                <div style="flex: 1;" ref="tj"></div>
                            </div>
                        </dv-border-box-7>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
                </el-tabs>
            </el-row>
        </div>
    </div>
</template>

<script>
import PvStationSelect from "@/components/html/pvStationSelect.vue";
import ToiletSelect from "@/components/html/toiletSelect.vue";

export default {
    name: "ToiletPv",
    components: { PvStationSelect, ToiletSelect },
    data() {
        return {
            datePickerDisabled: false,
            selectDateKey: 1,
            params1: [1, 2],
            options2: [
                { value: 1, label: '用电量' },
                { value: 2, label: '发电量' },
                { value: 3, label: '并网电量' },
                { value: 4, label: '购电电量' },
                { value: 5, label: '充电电量' },
            ],
            selectDateArray: [],
            datePickerType: "month",
            selectDateValue: null,
            selectDateTypeValue: 2,
            options: [
                { value: 2, label: '月' },
                { value: 3, label: '年' },
                { value: 4, label: '总' },
            ],
            activeName: "first",
            dict: {
                "BATTERY_BACKUP": "储能系统",
                "HOUSE_ROOF": "家用屋顶",
                "NORMAL": "正常",
                "CUTOFF": "中断",
            },
            pvId: 1,
            /** 总发电量 */
            generationValue: 0,
            station: {
                "toiletId": 0,
                "pvId": 0,
                "id": 0,
                "name": "",
                "locationAddress": "",
                "locationLat": 0,
                "locationLng": 0,
                "regionLevel1": 0,
                "regionLevel2": 0,
                "regionLevel3": 0,
                "regionNationId": 0,
                "regionTimezone": "",
                "startOperatingTime": "",
                "createdDate": "",
                "lastUpdateTime": "",
                "type": "",
                "installedCapacity": 0,
                "generationPower": 0,
                "batterySoc": 0,
                "gridInterconnectionType": "",
                "networkStatus": "",
                "totalRunningDayCount": 0,
                "usePower": 0,
                "batteryPower": 0,
                "wirePower": 0,
                "chargePower": 0,
                "purchasePower": 0,
                "gridPower": 0,
                "dischargePower": 0,
                "dataLastUpdate": ""
            },
            todayData: {
                "id": 0,
                "generationValue": 0,
                "generationRatio": 0,
                "gridRatio": 0,
                "chargeRatio": 0,
                "useValue": 0,
                "useRatio": 0,
                "buyRatio": 0,
                "useDischargeRatio": 0,
                "gridValue": 0,
                "buyValue": 0,
                "chargeValue": 0,
                "dischargeValue": 0,
                "fullPowerHours": 0,
                "year": 0,
                "month": 0,
                "day": 0
            },
            generationPowerArray: [],
            usePowerArray: [],
            timeArray: [],
            tjData: {}
        }
    },
    mounted() {
        this.pvId = 1
        this.selectDateValue = new Date().getFullYear() + '-' + (new Date().getMonth() + 1)
        this.timeArray = this.generateTimeArray()
        this.getBaseInfo()
    },
    methods: {
        calibrationData() {
            let year = this.selectDateValue ? this.selectDateValue.split("-")[0] : null;
            let month = this.selectDateValue ? this.selectDateValue.split("-")[1] : null;

            if (!year || !month) {
                this.$notify.error({
                    title: '错误',
                    message: '请设置正确的时间'
                });
                return
            }

            const loading = this.$loading({
                lock: true,
                text: '校准中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let count = 3;

            // 校准日数据
            this.postNo("photovoltaicStationData/updateData", {
                "stationId": this.station.id,
                "timeType": 2,
                "startTime": year + "-" + month + "-1",
                "endTime": year + "-" + month + "-" + new Date(year, month, 0).getDate(),
                "pvId": this.station.pvId
            }).then(res => {
                count = count - 1
            });

            // 校准月数据
            this.postNo("photovoltaicStationData/updateData", {
                "stationId": this.station.id,
                "timeType": 3,
                "startTime": year + "-" + month,
                "endTime": year + "-" + month,
                "pvId": this.station.pvId
            }).then(res => {
                count = count - 1
            });

            // 校准年数据
            this.postNo("photovoltaicStationData/updateData", {
                "stationId": this.station.id,
                "timeType": 4,
                "startTime": year,
                "endTime": year,
                "pvId": this.station.pvId
            }).then(res => {
                count = count - 1
            });

            let timer = setInterval(res => {
                if (count == 0) {
                    clearInterval(timer)
                    loading.close();
                    this.$notify({
                        title: '成功',
                        message: '校准结束',
                        type: 'success'
                    });

                    this.getTjData()
                }
            }, 100)

        },
        selectDateValueChange() {
            this.getTjData()
        },
        selectDateTypeValueChange() {
            this.datePickerDisabled = false;
            if (this.selectDateTypeValue == 3) {
                this.datePickerType = "year"
            } else if (this.selectDateTypeValue == 2) {
                this.datePickerType = "month"
            } else {
                this.datePickerDisabled = true
                this.datePickerType = "year"
            }
            this.selectDateKey++

            this.getTjData()
        },
        getTjData() {
            let dataType = this.selectDateTypeValue;
            let orderByColumn = "";
            let year = this.selectDateValue ? this.selectDateValue.split("-")[0] : null;
            let month = null;

            if (this.selectDateTypeValue == 2) {
                this.selectDateArray = this.getDaysInMonth(year, month);
                orderByColumn = "day";
                month = this.selectDateValue ? this.selectDateValue.split("-")[1] : null;
            } else if (this.selectDateTypeValue == 3) {
                this.selectDateArray = this.getMonthsInYear(year, month);
                orderByColumn = "month";
            } else {
                year = null;
                orderByColumn = "year";
                this.selectDateArray = this.getYears();
            }

            this.get("photovoltaicStationData/", {
                pageNum: 1,
                pageSize: 1000,
                orderByColumn: orderByColumn,
                isAsc: "asc",
                dataType: dataType,
                stationId: this.station.id,
                year: year,
                month: month,
                pvId: this.station.pvId
            }).then(res => {
                let data = res.data.rows;

                let map = null
                if (this.selectDateTypeValue == 2) {
                    map = data.reduce((result, item) => {
                        result.set(item.day, item);
                        return result;
                    }, new Map());
                } else if (this.selectDateTypeValue == 3) {
                    map = data.reduce((result, item) => {
                        result.set(item.month, item);
                        return result;
                    }, new Map());
                } else {
                    map = data.reduce((result, item) => {
                        result.set(item.year, item);
                        return result;
                    }, new Map());
                }


                let data1 = []; // 发电量
                let data2 = []; // 用电量
                let data3 = []; // 并网电量
                let data4 = []; // 购电电量
                let data5 = []; // 用电量
                for (let index = 0; index < this.selectDateArray.length; index++) {
                    const element = this.selectDateArray[index];
                    let item = map.get(element)
                    if (item) {
                        data1.push(item.generationValue)
                        data2.push(item.useValue)
                        data3.push(item.gridValue)
                        data4.push(item.buyValue)
                        data5.push(item.chargeValue)
                    } else {
                        data1.push(0)
                        data2.push(0)
                        data3.push(0)
                        data4.push(0)
                        data5.push(0)
                    }
                }

                this.tjData.data1 = data1
                this.tjData.data2 = data2
                this.tjData.data3 = data3
                this.tjData.data4 = data4
                this.tjData.data5 = data5

                this.tjChart()

            });
        },
        params1Change() {
            this.tjChart(true);
        },
        tjChart(update) {
            if (!this.myTjChart) {
                this.myTjChart = this.$echarts.init(this.$refs['tj']); // 初始化 DOM
            }

            let myChart = this.myTjChart;

            let option = {
                grid: {
                    top: 120
                },
                tooltip: {},
                legend: {
                    data: ['发电量', '用电量', '并网电量', '购电电量', '充电电量'],
                    left: 135,
                    top: 45,
                    textStyle: {
                        color: 'rgba(255, 255, 255, 1)'
                    }
                },
                xAxis: {
                    type: 'category',
                    data: this.selectDateArray,
                    axisLabel: {
                        color: 'white'
                    }
                },
                yAxis: {
                    name: '功率（kW）',
                    type: 'value',
                    nameTextStyle: {
                        color: "rgba(255, 255, 255, 1)"
                    },
                    axisLabel: {
                        color: 'white'
                    }
                },
                series: []
            };

            if (this.params1.indexOf(2) !== -1) {
                option.series.push({
                    name: "发电量",
                    data: this.tjData.data1,
                    type: 'bar'
                })
            }
            if (this.params1.indexOf(1) !== -1) {
                option.series.push({
                    name: "用电量",
                    data: this.tjData.data2,
                    visible: true,
                    type: 'bar'
                })
            }
            if (this.params1.indexOf(3) !== -1) {
                option.series.push({
                    name: "并网电量",
                    data: this.tjData.data3,
                    type: 'bar'
                })
            }
            if (this.params1.indexOf(4) !== -1) {
                option.series.push({
                    name: "购电电量",
                    data: this.tjData.data4,
                    type: 'bar'
                })
            }
            if (this.params1.indexOf(5) !== -1) {
                option.series.push({
                    name: "充电电量",
                    data: this.tjData.data5,
                    type: 'bar'
                })
            }

            option && myChart.setOption(option, update);
        },
        totalStatistics() {
            this.get("photovoltaicStationData/totalStatistics", {
                dataType: 4,
                stationId: this.station.id,
                // pvId: this.station.pvId
            }).then(res => {
                this.generationValue = res.data.data.generationValue;
            });
        },
        updateToiletId(id) {
            this.put("photovoltaicStation", {
                toiletId: id,
                pvId: this.station.pvId
            }).then(res => {

            });
        },
        getBaseInfo() {
            this.getStation()

            if (this.timer1) {
                clearInterval(this.timer1)
            }
            this.timer1 = setInterval(res => {
                this.getStation()
            }, 2 * 60000)
        },
        tabClick() {
            if (this.activeName == "second") {
                this.getHourData()
                this.getTodayData()

                if (this.timer2) {
                    clearInterval(this.timer2)
                }
                this.timer2 = setInterval(res => {
                    this.getHourData()
                    this.getTodayData()
                }, 2 * 60000)
            } else if (this.activeName == "third") {
                this.getTjData()
            } else if (this.activeName == "first") {
                this.getBaseInfo()
            }
        },
        getStation() {
            this.get("photovoltaicStation/realTime/" + this.pvId, {

            }).then(res => {
                // 控制运行时长为计算时长
                var daysDiff = Math.ceil((new Date() - new Date(res.data.data.startOperatingTime)) / (1000 * 60 * 60 * 24));
                res.data.data.totalRunningDayCount = daysDiff
                this.station = res.data.data;
                this.totalStatistics()
            });
        },
        b1Chat() {
            let myChart = this.$echarts.init(this.$refs['b1']); // 初始化 DOM
            let option = {
                title: {
                    text: '今日发电：' + this.todayData.generationValue + "kWh",
                    textStyle: {
                        color: "rgba(255, 255, 255, 1)"
                    },
                    left: "center"
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '今日发电',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        labelLine: {
                            show: false
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: 'bold'
                            }
                        },
                        data: [
                            { value: this.todayData.chargeValue ? this.todayData.chargeValue : 0.00, name: '用于充电' },
                            { value: this.todayData.generationRatio && this.todayData.generationValue ? (this.todayData.generationValue * this.todayData.generationRatio / 100).toFixed(2) : 0.00, name: '用于用电' },
                            { value: this.todayData.gridValue ? this.todayData.gridValue : 0.00, name: '用于并网' }
                        ]
                    }
                ]
            };
            myChart.setOption(option)
        },
        b2Chat() {
            let myChart = this.$echarts.init(this.$refs['b2']); // 初始化 DOM
            let option = {
                title: {
                    text: '今日用电：' + this.todayData.useValue + "kWh",
                    textStyle: {
                        color: "rgba(255, 255, 255, 1)"
                    },
                    left: "center"
                },
                tooltip: {
                    trigger: 'item'
                },
                series: [
                    {
                        name: '今日用电',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center'
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            { value: this.todayData.useValue && this.todayData.buyRatio ? (this.todayData.useValue * this.todayData.buyRatio / 100).toFixed(2) : 0.00, name: '来自购电' },
                            { value: this.todayData.useValue && this.todayData.useDischargeRatio ? (this.todayData.useValue * this.todayData.useDischargeRatio / 100).toFixed(2) : 0.00, name: '来自放电' },
                            { value: this.todayData.useValue && this.todayData.useRatio ? (this.todayData.useValue * this.todayData.useRatio / 100).toFixed(2) : 0.00, name: '来自发电' }
                        ]
                    }
                ]
            };
            myChart.setOption(option)
        },
        hourChat() {
            let myChart = this.$echarts.init(this.$refs['hours-box']); // 初始化 DOM

            let option = {
                title: {
                    text: '24小时趋势',
                    left: 20,
                    textStyle: {
                        color: "rgba(255, 255, 255, 1)"
                    },
                },
                grid: {
                    top: 80,
                    bottom: 80
                },
                toolbox: {
                    left: 'right',
                    iconStyle: {
                        borderColor: "rgba(255, 255, 255, 1)",
                    },
                    tooltip: {
                        backgroundColor: 'rgba(255, 255, 255, 1)',
                        textStyle: {
                            color: "rgba(255, 255, 255, 1)"
                        },
                    },
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        animation: false,
                        label: {
                            backgroundColor: 'rgba(255, 255, 255, 1)'
                        }
                    }
                },
                legend: {
                    data: ['发电功率', '用电功率'],
                    left: "center",
                    top: 25,
                    textStyle: {
                        color: 'rgba(255, 255, 255, 1)'
                    }
                },
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 100
                    },
                    {
                        type: 'inside',
                        realtime: true,
                        start: 0,
                        end: 100
                    }
                ],
                xAxis: [
                    {
                        type: 'category',
                        boundaryGap: false,
                        axisLine: { onZero: false },
                        // prettier-ignore
                        data: this.timeArray,
                        axisLabel: {
                            color: 'white'
                        }
                    }
                ],
                yAxis: [
                    {
                        name: '功率（kW）',
                        type: 'value',
                        nameTextStyle: {
                            color: "rgba(255, 255, 255, 1)"
                        },
                        axisLabel: {
                            color: 'white'
                        }
                    },
                    {
                        name: '功率（kW）',
                        nameLocation: 'start',
                        alignTicks: true,
                        type: 'value',
                        inverse: true,
                        nameTextStyle: {
                            color: "rgba(255, 255, 255, 1)"
                        },
                        axisLabel: {
                            color: 'white'
                        }
                    }
                ],
                series: [
                    {
                        name: '发电功率',
                        type: 'line',
                        areaStyle: {},
                        lineStyle: {
                            width: 1
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        markArea: {
                            silent: true,
                            itemStyle: {
                                opacity: 0.3
                            },
                            data: [
                                [
                                    {
                                        xAxis: '08:00'
                                    },
                                    {
                                        xAxis: '17:55'
                                    }
                                ]
                            ]
                        },
                        // prettier-ignore
                        data: this.generationPowerArray
                    },
                    {
                        name: '用电功率',
                        type: 'line',
                        yAxisIndex: 1,
                        areaStyle: {},
                        lineStyle: {
                            width: 1
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        markArea: {
                            silent: true,
                            itemStyle: {
                                opacity: 0.3
                            },
                            data: [
                                [
                                    {
                                        xAxis: '08:00'
                                    },
                                    {
                                        xAxis: '17:55'
                                    }
                                ]
                            ]
                        },
                        // prettier-ignore
                        data: this.usePowerArray
                    }
                ]
            }

            myChart.setOption(option)
        },
        getTodayData() {
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1; // 注意月份从 0 开始，需要加 1
            const day = currentDate.getDate();

            this.get("photovoltaicStationData/todayData/", {
                pageNum: 1,
                pageSize: 1000,
                orderByColumn: "date_time",
                isAsc: "asc",
                dataType: 2,
                stationId: this.station.id,
                year: year,
                month: month,
                day: day,
                pvId: this.station.pvId
            }).then(res => {
                let data = res.data.rows;
                if (data.length > 0) {
                    this.todayData = data[0];
                }

                this.b1Chat()
                this.b2Chat()
            });
        },
        getYears() {
            const year = new Date().getFullYear();
            const daysArray = [];
            for (let i = 2023; i <= year; i++) {
                daysArray.push(i);
            }
            return daysArray;
        },
        getMonthsInYear() {
            const daysArray = [];
            for (let i = 1; i <= 12; i++) {
                daysArray.push(i);
            }
            return daysArray;
        },
        getDaysInMonth(year, month) {
            // 使用 0 作为日期参数，表示获取上一个月的最后一天
            const lastDayOfMonth = new Date(year, month, 0).getDate();

            const daysArray = [];
            for (let i = 1; i <= lastDayOfMonth; i++) {
                daysArray.push(i);
            }

            return daysArray;
        },
        getHourData() {
            const currentDate = new Date();

            const year = currentDate.getFullYear();
            const month = currentDate.getMonth() + 1; // 注意月份从 0 开始，需要加 1
            const day = currentDate.getDate();

            this.get("photovoltaicStationData/", {
                pageNum: 1,
                pageSize: 1000,
                orderByColumn: "date_time",
                isAsc: "asc",
                dataType: 1,
                stationId: this.station.id,
                year: year,
                month: month,
                day: day
            }).then(res => {
                let data = res.data.rows;
                let data1 = [];
                let data2 = [];
                const map = data.reduce((result, item) => {
                    result.set(item.dateTime.split(" ")[1], item);
                    return result;
                }, new Map());

                for (let index = 0; index < this.timeArray.length; index++) {
                    const element = this.timeArray[index];
                    let item = map.get(element);
                    if (item) {
                        data1.push(item.generationPower / 1000)
                        data2.push(item.usePower / 1000)
                    } else {
                        data1.push(0)
                        data2.push(0)
                    }
                }
                this.generationPowerArray = data1;
                this.usePowerArray = data2;
                this.hourChat()
            });
        },
        generateTimeArray() {
            const times = [];
            for (let hour = 0; hour < 24; hour++) {
                for (let minute = 0; minute < 60; minute += 5) {
                    const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                    times.push(time);
                }
            }
            return times;
        },
        handleClick() {

        }
    }
}
</script>

<style scoped>
.select-group {
    display: flex;
    margin-left: 110px;
}

.select-group .dateType {
    width: 110px;
}

.select-group .dateType>>>.el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.select-group .data-input>>>.el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: none;
}

.select-group>>>.el-input__inner {
    background-color: rgba(255, 255, 255, 0);
    color: #fff;
}

.select-group>>>.el-tag.el-tag--info {
    background-color: rgba(0, 0, 0, 0);
    color: #fff;
}

.labeal-title {
    width: 150px;
    height: 30px;
    display: flex;
    align-items: center;
}

.labeal-value {
    height: 30px;
}

.my-row>>>.el-tabs__item {
    color: #fff;
    font-size: 20px;
}

.my-row>>>.is-active {
    color: rgb(69, 162, 255);
}

.my-row>>>.el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.my-row>>>.el-tabs__content {
    flex: 1;
}

.my-row>>>.el-tab-pane {
    height: 100%;
}

.baseInfo {
    font-size: 20px;
    padding: 0 70px 70px 70px;
}

.info-box {
    text-align: left;
    padding: 10px 0;
}

.box-stl {
    padding: 15px;
    box-sizing: content-box;
    display: flex;
    align-items: center;
    justify-content: center;
}

.gl-box {}

.container1 {
    position: relative;
    width: 200px;
    height: 100px;
    border-left: 2px solid rgb(178, 194, 228);
    border-bottom: 2px solid rgb(178, 194, 228);
    margin-left: 100px;
}

.container1 .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(180deg);
    left: 200px;
    top: 95px;
}

.container1 .ball {
    position: absolute;
    top: 0;
    width: 6px;
    height: 6px;
    margin-left: -4px;
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimation1 2s linear infinite;
}


@keyframes moveAnimation1 {
    0% {
        top: 0;
        left: 0;
    }

    50% {
        top: 98px;
        left: 0;
    }

    100% {
        top: 98px;
        left: 200px;
    }
}

.container1 .arrow-reverse {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(90deg);
    left: -4px;
    top: -4px;
}

.container1 .ball-reverse {
    position: absolute;
    bottom: -4px;
    width: 6px;
    height: 6px;
    /* margin-right: -4px; */
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimationReverse1 2s linear infinite;
}

@keyframes moveAnimationReverse1 {
    0% {
        bottom: -4px;
        right: 0;
    }

    50% {
        right: 198px;
        bottom: -4px;
    }

    100% {
        bottom: 94px;
        right: 198px;
    }
}

.container2 {
    position: relative;
    width: 200px;
    height: 100px;
    border-left: 2px solid rgb(178, 194, 228);
    border-top: 2px solid rgb(178, 194, 228);
    margin-left: 100px;
}

.container2 .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(180deg);
    left: 200px;
    top: -7px;
}

.container2 .ball {
    position: absolute;
    bottom: 0;
    width: 6px;
    height: 6px;
    margin-left: -4px;
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimation2 2s linear infinite;
}


@keyframes moveAnimation2 {
    0% {
        bottom: 0;
        left: 0;
    }

    50% {
        bottom: 98px;
        left: 0;
    }

    100% {
        bottom: 98px;
        left: 200px;
    }
}

.container2 .arrow-reverse {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(270deg);
    left: -4px;
    bottom: -4px;
}

.container2 .ball-reverse {
    position: absolute;
    top: -4px;
    right: 0;
    width: 6px;
    height: 6px;
    /* margin-right: -4px; */
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimationReverse2 2s linear infinite;
}

@keyframes moveAnimationReverse2 {
    0% {
        top: -4px;
        right: 0;
    }

    50% {
        top: -4px;
        right: 198px;
    }

    100% {
        top: 96px;
        right: 198px;
    }
}

.container3 {
    position: relative;
    width: 200px;
    height: 100px;
    border-right: 2px solid rgb(178, 194, 228);
    border-bottom: 2px solid rgb(178, 194, 228);
    margin-left: -100px;
}

.container3 .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(0deg);
    left: -6px;
    bottom: -7px;
}

.container3 .ball {
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 6px;
    margin-right: -4px;
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimation3 2s linear infinite;
}


@keyframes moveAnimation3 {
    0% {
        top: 0;
        right: 0;
    }

    50% {
        top: 98px;
        right: 0;
    }

    100% {
        top: 98px;
        right: 200px;
    }
}

.container3 .arrow-reverse {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(90deg);
    right: -4px;
    top: -4px;
}

.container3 .ball-reverse {
    position: absolute;
    top: 98px;
    right: 198px;
    width: 6px;
    height: 6px;
    /* margin-right: -4px; */
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimationReverse3 2s linear infinite;
}

@keyframes moveAnimationReverse3 {
    0% {
        top: 98px;
        right: 198px;
    }

    50% {
        top: 98px;
        right: -4px;
    }

    100% {
        top: 0;
        right: -4px;
    }
}

.container4 {
    position: relative;
    width: 200px;
    height: 100px;
    border-right: 2px solid rgb(178, 194, 228);
    border-top: 2px solid rgb(178, 194, 228);
    margin-left: -100px;
}

.container4 .arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(0deg);
    left: -6px;
    top: -7px;
}

.container4 .ball {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 6px;
    height: 6px;
    margin-right: -4px;
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimation4 2s linear infinite;
}


@keyframes moveAnimation4 {
    0% {
        bottom: 0;
        right: 0;
    }

    50% {
        bottom: 98px;
        right: 0;
    }

    100% {
        bottom: 98px;
        right: 200px;
    }
}

.container4 .arrow-reverse {
    position: absolute;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid rgb(178, 194, 228);
    transform: rotate(270deg);
    right: -4px;
    bottom: -4px;
}

.container4 .ball-reverse {
    position: absolute;
    top: -4px;
    left: -4px;
    width: 6px;
    height: 6px;
    /* margin-right: -4px; */
    border-radius: 50%;
    background-color: yellow;
    animation: moveAnimationReverse4 2s linear infinite;
}

@keyframes moveAnimationReverse4 {
    0% {
        top: -4px;
        left: -4px;
    }

    50% {
        top: -4px;
        left: 198px;
    }

    100% {
        top: 96px;
        left: 198px;
    }
}

.container-none>div {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/menu/toilet/toiletPv.vue